function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMutation, useQuery } from "@apollo/client";
import { useNavigation, useRoute } from "@react-navigation/native";
import pickBy from "lodash/pickBy";
import { useEffect, useLayoutEffect } from "react";
import { Linking } from "react-native";
import { z } from "zod";
import { getPatientSupporterRelation } from "@oui/lib/src/getPatientSupporterRelation";
import { graphql } from "@oui/lib/src/graphql/tada";
import { PatientSupporterRelation, PatientSupporterRelationSchema, UpdateOuiUserInputSchema, UpdateUserInputSchema } from "@oui/lib/src/types";
import { AddressFormInput } from "../components/AddressFormInput";
import { AuthenticationSettings } from "../components/AuthenticationSettings";
import { Button } from "../components/Button";
import { ErrorPresenter } from "../components/ErrorPresenter";
import { HeaderButtons, HeaderItem } from "../components/HeaderButtons";
import { PhoneFormInput } from "../components/PhoneInput";
import { ScrollView } from "../components/ScrollView";
import { TabHeader } from "../components/TabHeader";
import { Heading, Label, Text } from "../components/Text";
import { UserAddress } from "../components/UserAddress";
import { View } from "../components/View";
import { manifest } from "../constants";
import { Controller, Form, PickerFormInput, SwitchInputRender, TextFormInput, useZodForm } from "../form";
import { useLogout } from "../hooks/useLogout";
import { useI18n } from "../lib/i18n";
import { useTheme } from "../styles";
export var AccountSettingsQuery = graphql("\n    query AccountSettings {\n      user {\n        ID\n        email\n        givenName\n        phone\n        familyName\n        addresses {\n          city\n          line\n          postalCode\n          state\n          use\n        }\n        birthDate\n        role {\n          ID\n          supportee {\n            ID\n            relation\n            supportee {\n              ID\n              user {\n                ID\n                givenName\n                familyName\n              }\n            }\n          }\n          organization {\n            ID\n            isTrialOrganization\n          }\n          product {\n            ID\n            ifuUrl\n          }\n        }\n      }\n      ouiUser {\n        userID\n        pushNotificationsDisabled\n      }\n    }\n  ", []);
export var SaveAccountSettingsMutation = graphql("\n  mutation SaveAccountSettings($input: MutationUpdateUserInput!) {\n    updateUser(input: $input) {\n      ID\n      email\n      givenName\n      phone\n      familyName\n      addresses {\n        city\n        line\n        postalCode\n        state\n        use\n      }\n      birthDate\n    }\n  }\n");
export var UpdatePasswordMutation = graphql("\n  mutation UpdatePassword($input: UpdateOuiUserInput!) {\n    updateOuiUser(input: $input) {\n      ... on BaseError {\n        message\n      }\n      ... on CurrentOuiUser {\n        userID\n      }\n    }\n  }\n");
export var SetPushNotificationsDisabledMutation = graphql("\n  mutation SetPushNotificationsDisabled($pushNotificationsDisabled: Boolean!) {\n    setPushNotificationsDisabled(pushNotificationsDisabled: $pushNotificationsDisabled) {\n      userID\n      pushNotificationsDisabled\n    }\n  }\n");
var SaveAccountSettingsMutationSchema = UpdateUserInputSchema;
function Subheading(props) {
    var theme = useTheme().theme;
    return /*#__PURE__*/ _jsx(Text, {
        text: props.text,
        color: theme.color.gray300,
        style: {
            marginBottom: 6
        },
        size: 15,
        weight: "semibold"
    });
}
function Section(props) {
    return /*#__PURE__*/ _jsxs(View, {
        style: {
            gap: 10
        },
        testID: props.testID,
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                text: props.title,
                level: 2
            }),
            props.children
        ]
    });
}
var UpdatePasswordMutationSchema = UpdateOuiUserInputSchema.unwrap().extend({
    password: z.string().refine(function(val) {
        return val === '' || val.length >= 8;
    }, {
        message: 'Must contain at least 8 character(s)'
    }).optional(),
    confirmPassword: z.string().refine(function(val) {
        return val === '' || val.length >= 8;
    }, {
        message: 'Must match new password'
    }).optional()
}).refine(function(data) {
    return data.password === data.confirmPassword;
}, {
    message: 'Must match new password',
    path: [
        'confirmPassword'
    ]
});
function AccountSection() {
    var _route_params, _data_user;
    var route = useRoute();
    var data = useQuery(AccountSettingsQuery, {
        fetchPolicy: 'cache-only'
    }).data;
    var isEditing = ((_route_params = route.params) === null || _route_params === void 0 ? void 0 : _route_params.isEditing) === 'true';
    var $t = useI18n().$t;
    var _data_user_email;
    return isEditing ? /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Section, {
                title: $t({
                    id: 'AccountSettings_accountHeading',
                    defaultMessage: 'Account'
                }),
                testID: "AccountDetailsSection",
                children: /*#__PURE__*/ _jsx(Form, {
                    mutate: SaveAccountSettingsMutation,
                    schema: SaveAccountSettingsMutationSchema,
                    prepareVariables: function(formData) {
                        return {
                            input: {
                                userID: data.user.ID,
                                user: formData
                            }
                        };
                    },
                    getDefaultValues: function() {
                        var _data_user, _data_user1, _data_user2;
                        return {
                            givenName: data === null || data === void 0 ? void 0 : (_data_user = data.user) === null || _data_user === void 0 ? void 0 : _data_user.givenName,
                            familyName: data === null || data === void 0 ? void 0 : (_data_user1 = data.user) === null || _data_user1 === void 0 ? void 0 : _data_user1.familyName,
                            email: data === null || data === void 0 ? void 0 : (_data_user2 = data.user) === null || _data_user2 === void 0 ? void 0 : _data_user2.email
                        };
                    },
                    buttons: {
                        submit: {
                            text: 'Save',
                            testID: 'AccountDetailsSection_saveButton',
                            variant: 'contained'
                        }
                    },
                    children: function(form) {
                        return /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(TextFormInput, {
                                    control: form.control,
                                    label: $t({
                                        id: 'AccountSettings_givenNameLabel',
                                        defaultMessage: 'First name'
                                    }),
                                    name: "givenName"
                                }),
                                /*#__PURE__*/ _jsx(TextFormInput, {
                                    control: form.control,
                                    label: $t({
                                        id: 'AccountSettings_familyNameLabel',
                                        defaultMessage: 'Last name'
                                    }),
                                    name: "familyName"
                                }),
                                /*#__PURE__*/ _jsx(TextFormInput, {
                                    control: form.control,
                                    label: $t({
                                        id: 'AccountSettings_email',
                                        defaultMessage: 'Email'
                                    }),
                                    name: "email"
                                })
                            ]
                        });
                    }
                })
            }),
            /*#__PURE__*/ _jsx(Section, {
                title: $t({
                    id: 'AccountSettings_passwordHeading',
                    defaultMessage: 'Password'
                }),
                testID: "AccountPasswordSection",
                children: /*#__PURE__*/ _jsx(Form, {
                    mutate: UpdatePasswordMutation,
                    schema: UpdatePasswordMutationSchema,
                    prepareVariables: function(formData) {
                        return {
                            input: {
                                currentPassword: formData.currentPassword,
                                password: formData.password
                            }
                        };
                    },
                    getDefaultValues: function() {
                        return {
                            currentPassword: '',
                            password: '',
                            confirmPassword: ''
                        };
                    },
                    buttons: {
                        submit: {
                            text: 'Save',
                            testID: 'AccountPasswordSection_saveButton',
                            variant: 'contained'
                        }
                    },
                    children: function(form) {
                        return /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(TextFormInput, {
                                    control: form.control,
                                    label: $t({
                                        id: 'AccountSettings_currentPasswordLabel',
                                        defaultMessage: 'Current password'
                                    }),
                                    placeholder: "********",
                                    secureTextEntry: true,
                                    autoComplete: "current-password",
                                    name: "currentPassword"
                                }),
                                /*#__PURE__*/ _jsx(TextFormInput, {
                                    control: form.control,
                                    label: $t({
                                        id: 'AccountSettings_newPasswordLabel',
                                        defaultMessage: 'New password'
                                    }),
                                    placeholder: "********",
                                    secureTextEntry: true,
                                    autoComplete: "new-password",
                                    name: "password"
                                }),
                                /*#__PURE__*/ _jsx(TextFormInput, {
                                    control: form.control,
                                    label: $t({
                                        id: 'AccountSettings_confirmPasswordLabel',
                                        defaultMessage: 'Confirm new password'
                                    }),
                                    placeholder: "********",
                                    secureTextEntry: true,
                                    autoComplete: "new-password",
                                    name: "confirmPassword"
                                })
                            ]
                        });
                    }
                })
            })
        ]
    }) : /*#__PURE__*/ _jsx(Section, {
        title: $t({
            id: 'AccountSettings_accountHeading',
            defaultMessage: 'Account'
        }),
        children: /*#__PURE__*/ _jsxs(View, {
            style: {
                gap: 20
            },
            children: [
                /*#__PURE__*/ _jsxs(View, {
                    children: [
                        /*#__PURE__*/ _jsx(Subheading, {
                            text: $t({
                                id: 'AccountSettings_nameLabel',
                                defaultMessage: 'Name'
                            })
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            testID: "AccountSettings_name",
                            text: (data === null || data === void 0 ? void 0 : data.user) ? "".concat(data.user.givenName, " ").concat(data.user.familyName) : ''
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(View, {
                    children: [
                        /*#__PURE__*/ _jsx(Subheading, {
                            text: $t({
                                id: 'AccountSettings_emailLabel',
                                defaultMessage: 'Email'
                            })
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            testID: "AccountSettings_email",
                            text: (_data_user_email = data === null || data === void 0 ? void 0 : (_data_user = data.user) === null || _data_user === void 0 ? void 0 : _data_user.email) !== null && _data_user_email !== void 0 ? _data_user_email : ''
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(AuthenticationSettings, {})
            ]
        })
    });
}
var ContactSectionSchema = z.preprocess(function(unknownValue) {
    var _value_addresses;
    var value = unknownValue;
    // Filter out empty addresses
    value.addresses = (_value_addresses = value.addresses) === null || _value_addresses === void 0 ? void 0 : _value_addresses.filter(function(a) {
        var _a_line;
        return a.city || a.postalCode || a.state || ((_a_line = a.line) === null || _a_line === void 0 ? void 0 : _a_line.some(function(l) {
            return l;
        }));
    });
    return value;
}, SaveAccountSettingsMutationSchema);
function ContactSection() {
    var _route_params;
    var route = useRoute();
    var data = useQuery(AccountSettingsQuery, {
        fetchPolicy: 'cache-only'
    }).data;
    var isEditing = ((_route_params = route.params) === null || _route_params === void 0 ? void 0 : _route_params.isEditing) === 'true';
    var $t = useI18n().$t;
    return /*#__PURE__*/ _jsx(Section, {
        title: $t({
            id: 'AccountSettings_contactHeading',
            defaultMessage: 'Contact information'
        }),
        testID: "ContactSection",
        children: isEditing ? /*#__PURE__*/ _jsx(Form, {
            mutate: SaveAccountSettingsMutation,
            schema: ContactSectionSchema,
            prepareVariables: function(formData) {
                return {
                    input: {
                        userID: data.user.ID,
                        user: formData
                    }
                };
            },
            getDefaultValues: function() {
                var _data_user, _data_user1;
                var _data_user_addresses;
                return {
                    phone: data === null || data === void 0 ? void 0 : (_data_user = data.user) === null || _data_user === void 0 ? void 0 : _data_user.phone,
                    addresses: (_data_user_addresses = data === null || data === void 0 ? void 0 : (_data_user1 = data.user) === null || _data_user1 === void 0 ? void 0 : _data_user1.addresses) !== null && _data_user_addresses !== void 0 ? _data_user_addresses : []
                };
            },
            buttons: {
                submit: {
                    text: 'Save',
                    testID: 'ContactSection_saveButton',
                    variant: 'contained'
                }
            },
            children: function(form) {
                return /*#__PURE__*/ _jsxs(View, {
                    testID: "ContactSection_edit",
                    spacing: 8,
                    children: [
                        /*#__PURE__*/ _jsx(AddressFormInput, {
                            control: form.control,
                            name: "addresses.0",
                            requiresMailingAddress: false
                        }),
                        /*#__PURE__*/ _jsx(PhoneFormInput, {
                            control: form.control,
                            label: $t({
                                id: 'AccountSettings_phoneLabel',
                                defaultMessage: 'Phone number'
                            }),
                            placeholder: $t({
                                id: 'AccountSettings_phonePlaceholder',
                                defaultMessage: 'Phone number'
                            }),
                            name: "phone"
                        })
                    ]
                });
            }
        }) : data && data.user ? /*#__PURE__*/ _jsxs(View, {
            spacing: 20,
            children: [
                (data === null || data === void 0 ? void 0 : data.user.addresses) && Object.keys(pickBy(data.user.addresses)).length ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Subheading, {
                            text: $t({
                                id: 'AccountSettings_addressLabel',
                                defaultMessage: 'Home address'
                            })
                        }),
                        /*#__PURE__*/ _jsx(UserAddress, _object_spread({}, data.user.addresses[0]))
                    ]
                }) : null,
                /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Subheading, {
                            text: $t({
                                id: 'AccountSettings_phoneLabel',
                                defaultMessage: 'Phone number'
                            })
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            testID: "ContactSection_phone",
                            text: data.user.phone || $t({
                                id: 'AccountSettings_unknownValue',
                                defaultMessage: 'Unknown'
                            })
                        })
                    ]
                })
            ]
        }) : null
    });
}
var AllowPushSchema = z.object({
    allowPush: z.boolean()
});
function NotificationSection() {
    var _data_ouiUser;
    var $t = useI18n().$t;
    var data = useQuery(AccountSettingsQuery, {
        fetchPolicy: 'cache-only'
    }).data;
    var _useMutation = _sliced_to_array(useMutation(SetPushNotificationsDisabledMutation), 1), setPush = _useMutation[0];
    var form = useZodForm(AllowPushSchema, {
        defaultValues: {
            allowPush: !(data === null || data === void 0 ? void 0 : (_data_ouiUser = data.ouiUser) === null || _data_ouiUser === void 0 ? void 0 : _data_ouiUser.pushNotificationsDisabled)
        }
    });
    var control = form.control, watch = form.watch;
    var allowPush = watch('allowPush');
    useEffect(function() {
        var _data_ouiUser;
        if (typeof allowPush === 'boolean' && typeof (data === null || data === void 0 ? void 0 : (_data_ouiUser = data.ouiUser) === null || _data_ouiUser === void 0 ? void 0 : _data_ouiUser.pushNotificationsDisabled) === 'boolean') {
            var _data_ouiUser1;
            // prevent sending unecessary mutations
            if ((data === null || data === void 0 ? void 0 : (_data_ouiUser1 = data.ouiUser) === null || _data_ouiUser1 === void 0 ? void 0 : _data_ouiUser1.pushNotificationsDisabled) !== !allowPush) {
                void setPush({
                    variables: {
                        pushNotificationsDisabled: !allowPush
                    }
                });
            }
        }
    }, [
        setPush,
        allowPush,
        data === null || data === void 0 ? void 0 : data.ouiUser
    ]);
    return /*#__PURE__*/ _jsx(Section, {
        title: $t({
            id: 'AccountSettings_notificationsHeading',
            defaultMessage: 'Notification settings'
        }),
        children: /*#__PURE__*/ _jsxs(View, {
            row: true,
            style: {
                justifyContent: 'space-between'
            },
            children: [
                /*#__PURE__*/ _jsx(Label, {
                    text: $t({
                        id: 'AccountSettings_pushNotificationsLabel',
                        defaultMessage: 'Allow push notifications'
                    }),
                    role: "none"
                }),
                /*#__PURE__*/ _jsx(Controller, {
                    control: control,
                    render: function(props) {
                        return SwitchInputRender(props, {
                            'aria-label': $t({
                                id: 'AccountSettings_pushNotificationsLabel',
                                defaultMessage: 'Allow push notifications'
                            })
                        });
                    },
                    name: "allowPush"
                })
            ]
        })
    });
}
export var AccountSettingsRelationMutation = graphql("\n  mutation AccountSettingsRelation($relation: PatientSupporterRelationInput!) {\n    setPatientSupporterRelation(input: $relation) {\n      ID\n      supporterID\n      patientID\n      relation\n      roleSupportee {\n        ID\n        relation\n      }\n    }\n  }\n");
function ConnectedSection() {
    var _route_params, _data_user_role, _data_user;
    var route = useRoute();
    var data = useQuery(AccountSettingsQuery, {
        fetchPolicy: 'cache-only'
    }).data;
    var isEditing = ((_route_params = route.params) === null || _route_params === void 0 ? void 0 : _route_params.isEditing) === 'true';
    var $t = useI18n().$t;
    var supportee = data === null || data === void 0 ? void 0 : (_data_user = data.user) === null || _data_user === void 0 ? void 0 : (_data_user_role = _data_user.role) === null || _data_user_role === void 0 ? void 0 : _data_user_role.supportee;
    if (!supportee) return null;
    var _supportee_supportee_user_givenName, _supportee_supportee_user_familyName;
    var patient = /*#__PURE__*/ _jsxs(View, {
        children: [
            /*#__PURE__*/ _jsx(Subheading, {
                text: $t({
                    id: 'Account_patientLabel',
                    defaultMessage: 'Patient'
                })
            }),
            /*#__PURE__*/ _jsx(Text, {
                testID: "ConnectedSection_patientName",
                text: [
                    (_supportee_supportee_user_givenName = supportee === null || supportee === void 0 ? void 0 : supportee.supportee.user.givenName) !== null && _supportee_supportee_user_givenName !== void 0 ? _supportee_supportee_user_givenName : '',
                    (_supportee_supportee_user_familyName = supportee === null || supportee === void 0 ? void 0 : supportee.supportee.user.familyName) !== null && _supportee_supportee_user_familyName !== void 0 ? _supportee_supportee_user_familyName : ''
                ].join(' ')
            })
        ]
    });
    return /*#__PURE__*/ _jsx(Section, {
        title: $t({
            id: 'Account_connectedHeading',
            defaultMessage: 'Connected'
        }),
        testID: "ConnectedSection",
        children: isEditing ? /*#__PURE__*/ _jsx(Form, {
            mutate: AccountSettingsRelationMutation,
            schema: z.object({
                relation: PatientSupporterRelationSchema
            }),
            prepareVariables: function(formData) {
                return {
                    relation: {
                        patientID: supportee.supportee.ID,
                        relation: formData.relation
                    }
                };
            },
            getDefaultValues: function() {
                return {
                    relation: supportee === null || supportee === void 0 ? void 0 : supportee.relation
                };
            },
            buttons: {
                submit: {
                    text: 'Save',
                    testID: 'ConnectedSection_saveButton',
                    variant: 'contained'
                }
            },
            children: function(form) {
                return /*#__PURE__*/ _jsxs(View, {
                    style: {
                        gap: 20
                    },
                    children: [
                        patient,
                        /*#__PURE__*/ _jsx(PickerFormInput, {
                            control: form.control,
                            name: "relation",
                            items: Object.values(PatientSupporterRelation).map(function(v) {
                                return {
                                    label: getPatientSupporterRelation({
                                        $t: $t,
                                        patientSupporterRelation: v
                                    }),
                                    value: v
                                };
                            }),
                            label: $t({
                                id: 'Account_patientRelationLabel',
                                defaultMessage: 'Relation'
                            })
                        })
                    ]
                });
            }
        }) : /*#__PURE__*/ _jsxs(View, {
            style: {
                gap: 20
            },
            children: [
                patient,
                /*#__PURE__*/ _jsxs(View, {
                    children: [
                        /*#__PURE__*/ _jsx(Subheading, {
                            text: $t({
                                id: 'Account_patientRelationHeading',
                                defaultMessage: 'Your relation'
                            })
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            testID: "ConnectedSection_patientRelation",
                            text: (supportee === null || supportee === void 0 ? void 0 : supportee.relation) ? getPatientSupporterRelation({
                                $t: $t,
                                patientSupporterRelation: supportee.relation
                            }) : ''
                        })
                    ]
                })
            ]
        })
    });
}
function LegalSection() {
    var _route_params, _data_user_role, _data_user;
    var navigation = useNavigation();
    var route = useRoute();
    var isEditing = ((_route_params = route.params) === null || _route_params === void 0 ? void 0 : _route_params.isEditing) === 'true';
    var $t = useI18n().$t;
    var data = useQuery(AccountSettingsQuery, {
        fetchPolicy: 'cache-only'
    }).data;
    var ifuUrl = data === null || data === void 0 ? void 0 : (_data_user = data.user) === null || _data_user === void 0 ? void 0 : (_data_user_role = _data_user.role) === null || _data_user_role === void 0 ? void 0 : _data_user_role.product.ifuUrl;
    return isEditing ? null : /*#__PURE__*/ _jsx(Section, {
        title: $t({
            id: 'AccountSettings_legalHeading',
            defaultMessage: 'Legal'
        }),
        children: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(View, {
                    style: {
                        gap: 8
                    },
                    children: /*#__PURE__*/ _jsx(Button, {
                        variant: "text",
                        text: $t({
                            id: 'AccountSettings_termsOfServiceLink',
                            defaultMessage: 'Terms of service & privacy policy'
                        }),
                        onPress: function() {
                            navigation.navigate('TermsAndPrivacy');
                        }
                    })
                }),
                ifuUrl ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            variant: "text",
                            text: $t({
                                id: 'AccountSettings_instructionsForUseLink',
                                defaultMessage: 'Instructions for use'
                            }),
                            onPress: function() {
                                return Linking.openURL(ifuUrl);
                            }
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            text: $t({
                                id: 'AccountSettings_investigationalDevice',
                                defaultMessage: 'CAUTION—Investigational device. Limited by Federal law to investigational use.'
                            })
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            text: $t({
                                id: 'AccountSettings_investigationalDeviceVersion',
                                defaultMessage: 'Version: {version}'
                            }, {
                                version: manifest.version
                            })
                        })
                    ]
                }) : null
            ]
        })
    });
}
/**
 * Displays and allows editing of the current user’s settings / account
 * information.
 *
 * Contains the following sections:
 *
 * - Account
 * - Connected (For users with supportees)
 * - Contact info
 * - Notifications
 * - Legal
 *   - Shows IFU if available for product
 *
 * {@adf 💾̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̅̃̀̀̆̉̀̀̆̎̀̀̆̇̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̇̇̀̀̆̉̀̀̆̄̀̀̇̄̀̀̆̈̀̀̂̂̀̀̃̊̀̀̃́̀̀̃̆̀̀̂̎̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̈̀̀̂̌̀̀̂̂̀̀̆̌̀̀̆́̀̀̇̉̀̀̆̏̀̀̇̅̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̃̀̀̆̅̀̀̆̎̀̀̇̄̀̀̆̅̀̀̇̂̀̀̂̂̀̀̇̍̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̎̀̀̇̄̀̀̆̅̀̀̆̎̀̀̇̄̀̀̂̂̀̀̃̊̀̀̅̋̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̆̀̀̆̉̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̉̀̀̆̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̃̀̀̀̃́̀̀̃̆̀̀̃̂̀̀̆̃̀̀̆̄̀̀̃̉̀̀̆̂̀̀̂̍̀̀̆̅̀̀̆̅̀̀̃̅̀̀̃̂̀̀̂̍̀̀̃̄̀̀̆̄̀̀̃̉̀̀̆̅̀̀̂̍̀̀̃̉̀̀̃̃̀̀̆̆̀̀̃̇̀̀̂̍̀̀̃̃̀̀̃́̀̀̃̅̀̀̆̆̀̀̆̆̀̀̃̈̀̀̆́̀̀̃́̀̀̃̃̀̀̃̆̀̀̃̈̀̀̃̃̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̌̀̀̆̌̀̀̆̅̀̀̆̃̀̀̇̄̀̀̆̉̀̀̆̏̀̀̆̎̀̀̂̂̀̀̃̊̀̀̂̂̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̈̀̀̆̅̀̀̆̉̀̀̆̇̀̀̆̈̀̀̇̄̀̀̂̂̀̀̃̊̀̀̃̂̀̀̃̀̀̀̃̄̀̀̃̈̀̀̂̌̀̀̂̂̀̀̇̇̀̀̆̉̀̀̆̄̀̀̇̄̀̀̆̈̀̀̂̂̀̀̃̊̀̀̃̅̀̀̃́̀̀̃̅̀̀̇̍̀̀̇̍̀̀̅̍̀̀̇̍}
 *
 * {@adf 💾̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̅̃̀̀̆̉̀̀̆̎̀̀̆̇̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̇̇̀̀̆̉̀̀̆̄̀̀̇̄̀̀̆̈̀̀̂̂̀̀̃̊̀̀̃́̀̀̃̆̀̀̂̎̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̈̀̀̂̌̀̀̂̂̀̀̆̌̀̀̆́̀̀̇̉̀̀̆̏̀̀̇̅̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̃̀̀̆̅̀̀̆̎̀̀̇̄̀̀̆̅̀̀̇̂̀̀̂̂̀̀̇̍̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̎̀̀̇̄̀̀̆̅̀̀̆̎̀̀̇̄̀̀̂̂̀̀̃̊̀̀̅̋̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̆̀̀̆̉̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̉̀̀̆̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̃̄̀̀̃̇̀̀̆̄̀̀̆̃̀̀̃̈̀̀̃̇̀̀̆̄̀̀̃̆̀̀̂̍̀̀̃̅̀̀̆̆̀̀̃̅̀̀̆̅̀̀̂̍̀̀̃̄̀̀̆́̀̀̃̆̀̀̃̃̀̀̂̍̀̀̆̂̀̀̃̄̀̀̃̂̀̀̃̄̀̀̂̍̀̀̃̇̀̀̆̃̀̀̃̇̀̀̃̃̀̀̆̃̀̀̃̃̀̀̃̄̀̀̃̄̀̀̃̀̀̀̆̅̀̀̃̆̀̀̃̀̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̌̀̀̆̌̀̀̆̅̀̀̆̃̀̀̇̄̀̀̆̉̀̀̆̏̀̀̆̎̀̀̂̂̀̀̃̊̀̀̂̂̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̈̀̀̆̅̀̀̆̉̀̀̆̇̀̀̆̈̀̀̇̄̀̀̂̂̀̀̃̊̀̀̃̂̀̀̃̀̀̀̃̄̀̀̃̈̀̀̂̌̀̀̂̂̀̀̇̇̀̀̆̉̀̀̆̄̀̀̇̄̀̀̆̈̀̀̂̂̀̀̃̊̀̀̃̅̀̀̃́̀̀̃̅̀̀̇̍̀̀̇̍̀̀̅̍̀̀̇̍}
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-18}
 */ export function AccountSettings(props) {
    var _route_params;
    var navigation = useNavigation();
    var route = useRoute();
    var $t = useI18n().$t;
    var error = useQuery(AccountSettingsQuery).error;
    var logout = useLogout();
    var isEditing = ((_route_params = route.params) === null || _route_params === void 0 ? void 0 : _route_params.isEditing) === 'true';
    var theme = useTheme().theme;
    useLayoutEffect(function() {
        if (isEditing) {
            navigation.setOptions({
                header: undefined,
                headerTitle: $t({
                    id: 'AccountSettings_editHeading',
                    defaultMessage: 'Edit account settings'
                }),
                headerRight: undefined,
                headerLeft: function(param) {
                    var tintColor = param.tintColor;
                    return /*#__PURE__*/ _jsx(HeaderButtons, {
                        left: true,
                        children: /*#__PURE__*/ _jsx(HeaderItem, {
                            testID: "AccountSettings_cancelButton",
                            "aria-label": $t({
                                id: 'AccountSettings_cancelButton',
                                defaultMessage: 'Cancel'
                            }),
                            title: "",
                            onPress: function() {
                                navigation.setParams({
                                    isEditing: 'false'
                                });
                            },
                            iconName: "arrow-left",
                            color: tintColor
                        })
                    });
                }
            });
        } else {
            var getHeaderRight = function(param) {
                var tintColor = param.tintColor;
                return /*#__PURE__*/ _jsx(HeaderItem, {
                    "aria-label": $t({
                        id: 'AccountSettings_editButton',
                        defaultMessage: 'Edit'
                    }),
                    title: "",
                    onPress: function() {
                        return navigation.setParams({
                            isEditing: 'true'
                        });
                    },
                    iconName: "edit",
                    color: tintColor,
                    testID: "AccountSettings_editButton"
                });
            };
            if (props.tabScreen) {
                navigation.setOptions({
                    header: function(param) {
                        var _param_options = param.options, tintColor = _param_options.headerTintColor;
                        return /*#__PURE__*/ _jsx(TabHeader, {
                            borderBottom: true,
                            heading: $t({
                                id: 'AccountSettings_heading',
                                defaultMessage: 'Account'
                            }),
                            headerRight: getHeaderRight({
                                tintColor: tintColor
                            })
                        });
                    }
                });
            } else {
                navigation.setOptions({
                    headerTitle: 'Account settings',
                    headerLeft: undefined,
                    headerRight: function(param) {
                        var tintColor = param.tintColor;
                        return /*#__PURE__*/ _jsx(HeaderButtons, {
                            children: getHeaderRight({
                                tintColor: tintColor
                            })
                        });
                    }
                });
            }
        }
    }, [
        navigation,
        isEditing,
        $t,
        theme,
        props.tabScreen
    ]);
    return /*#__PURE__*/ _jsx(ScrollView, {
        testID: "AccountSettings",
        children: /*#__PURE__*/ _jsxs(View, {
            style: {
                padding: 20,
                gap: 60
            },
            children: [
                /*#__PURE__*/ _jsx(ErrorPresenter, {
                    error: error
                }),
                /*#__PURE__*/ _jsx(AccountSection, {}),
                /*#__PURE__*/ _jsx(ConnectedSection, {}),
                /*#__PURE__*/ _jsx(ContactSection, {}),
                isEditing ? null : /*#__PURE__*/ _jsx(NotificationSection, {}),
                /*#__PURE__*/ _jsx(LegalSection, {}),
                isEditing ? null : /*#__PURE__*/ _jsx(Button, {
                    style: {
                        marginTop: 40
                    },
                    text: $t({
                        id: 'AccountSettings_logOutLink',
                        defaultMessage: 'Log out'
                    }),
                    variant: "text",
                    onPress: logout
                })
            ]
        })
    }, isEditing.toString());
}
